// extracted by mini-css-extract-plugin
module.exports = {"root":"form-label_root__Z8ge1"};